import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Create root only once and reuse it
const container = document.getElementById("root");
let root = ReactDOM.createRoot(container);

if (!root) {
  root = ReactDOM.createRoot(container);
}

// ฟังก์ชันสำหรับลดความยาวของข้อความ
const truncateMessage = (msg, maxLength = 100) => {
  return msg.length > maxLength ? msg.substring(0, maxLength) + '...' : msg;
};

// ดักจับข้อความเตือนและ error เกี่ยวกับ defaultProps
const handleDefaultPropsMessage = (originalFunc, type) => (message, ...args) => {
  if (typeof message === 'string' && 
      (message.includes('defaultProps will be removed') || 
       message.includes('Support for defaultProps'))) {
    const componentName = message.match(/at (\w+)/)?.[1] || 'Unknown';
    console.log(`${type} (${componentName}): ${truncateMessage(message)}`);
  } else {
    originalFunc(message, ...args);
  }
};

console.warn = handleDefaultPropsMessage(console.warn, 'Warn');
console.error = handleDefaultPropsMessage(console.error, 'Error');

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);